import { useCallback } from 'react';

import { useAppDispatch } from '@/store/hooks';
import { getUserByToken } from '@/store/userSlice';
import { getAccessToken } from '@/utils/localStorage';

/**
 * Refreshes Redux session user (`useCurrentUser`) after profile-affecting mutations.
 * Use alongside React Query `invalidateKeys` when those keys have no active consumer yet.
 */
export function useRefreshSessionUser() {
  const dispatch = useAppDispatch();

  return useCallback(async () => {
    const token = getAccessToken();
    if (token) {
      await dispatch(getUserByToken(token));
    }
  }, [dispatch]);
}
